import { useState, useEffect } from 'react';
import { api } from '../utils/api';
import toast from 'react-hot-toast';

const ICONS = ['💰','💼','💻','📈','🍔','🚗','🏠','❤️','🎮','📚','👕','⚡','🎬','🍿','🎁','🍽️','☕','🏋️','✈️','🎸','🛒','💊','🐾','🎓','🛣️','🚦','🛞','🏍️','🛵','🚙'];
const COLORS = ['#7C6FFF','#00D4AA','#FF5470','#FFB800','#00B8FF','#FF9F43','#A29BFE','#FD79A8','#55EFC4','#E17055','#74B9FF','#FDCB6E'];
const EMPTY = { name:'', type:'expense', icon:'💰', color:'#7C6FFF', parent_id:'' };

export default function Categories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [tab, setTab] = useState('expense');

  const load = async () => {
    setLoading(true);
    try { setCategories(await api.get('/categories')); } catch {}
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const openAdd = (parentId = null) => {
    const parent = parentId ? categories.find(c => c.id === parentId) : null;
    setForm({ ...EMPTY, parent_id: parentId || '', type: parent?.type || tab });
    setEditId(null); setShowModal(true);
  };

  const openEdit = (c) => {
    setForm({ name:c.name, type:c.type, icon:c.icon, color:c.color, parent_id:c.parent_id||'' });
    setEditId(c.id); setShowModal(true);
  };

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      if (editId) { await api.put(`/categories/${editId}`, form); toast.success('Categoría actualizada'); }
      else { await api.post('/categories', form); toast.success('Categoría creada'); }
      setShowModal(false); load();
    } catch (err) { toast.error(err.message); }
    setSaving(false);
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`¿Eliminar "${name}"? Las transacciones asociadas quedarán sin categoría.`)) return;
    try { await api.delete(`/categories/${id}`); toast.success('Eliminada'); load(); }
    catch (err) { toast.error(err.message); }
  };

  const filtered = categories.filter(c => c.type === tab);
  const parents = filtered.filter(c => !c.parent_id);
  // For modal: parent options of same type
  const parentOptions = categories.filter(c => c.type === (form.parent_id ? categories.find(x=>x.id===parseInt(form.parent_id))?.type : form.type) && !c.parent_id);

  return (
    <div style={styles.page} className="animate-fadeIn">
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <h2 style={{ fontFamily:'var(--font-display)', fontSize:'1.4rem' }}>Categorías</h2>
        <button className="btn btn-primary" onClick={() => openAdd()}>+ Nueva</button>
      </div>

      {/* Tabs */}
      <div style={styles.tabs}>
        {[['expense','Gastos'],['income','Ingresos']].map(([v,l]) => (
          <button key={v} onClick={() => setTab(v)}
            style={{ ...styles.tab, ...(tab===v ? styles.tabActive : {}) }}>
            {l}
          </button>
        ))}
      </div>

      {loading ? (
        <div style={{ display:'flex', justifyContent:'center', padding:40 }}>
          <div className="spinner" style={{ width:32, height:32 }} />
        </div>
      ) : parents.length === 0 ? (
        <div style={styles.empty}>
          <span style={{ fontSize:44 }}>🗂️</span>
          <p>Sin categorías de {tab === 'expense' ? 'gastos' : 'ingresos'}</p>
        </div>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
          {parents.map(cat => (
            <div key={cat.id} className="card" style={{ padding:0, overflow:'hidden' }}>
              {/* Parent row */}
              <div style={styles.catRow}>
                <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                  <div style={{ width:40, height:40, borderRadius:10, background:`${cat.color}20`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:20, flexShrink:0 }}>
                    {cat.icon}
                  </div>
                  <div>
                    <p style={{ fontWeight:600 }}>{cat.name}</p>
                    <p style={{ fontSize:'0.75rem', color:'var(--text-secondary)', marginTop:2 }}>
                      {cat.subcategories?.length > 0 ? `${cat.subcategories.length} subcategoría${cat.subcategories.length > 1 ? 's' : ''}` : 'Sin subcategorías'}
                    </p>
                  </div>
                </div>
                <div style={{ display:'flex', gap:6 }}>
                  <button className="btn btn-secondary btn-sm" onClick={() => openAdd(cat.id)} title="Agregar subcategoría">
                    + Sub
                  </button>
                  <button className="btn btn-ghost btn-icon btn-sm" onClick={() => openEdit(cat)}>✏️</button>
                  <button className="btn btn-danger btn-icon btn-sm" onClick={() => handleDelete(cat.id, cat.name)}>🗑</button>
                </div>
              </div>

              {/* Subcategories */}
              {cat.subcategories?.length > 0 && (
                <div style={styles.subList}>
                  {cat.subcategories.map(sub => (
                    <div key={sub.id} style={styles.subRow}>
                      <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                        <div style={{ width:32, height:32, borderRadius:8, background:`${sub.color}20`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:16 }}>
                          {sub.icon}
                        </div>
                        <p style={{ fontSize:'0.88rem', fontWeight:500 }}>{sub.name}</p>
                      </div>
                      <div style={{ display:'flex', gap:4 }}>
                        <button className="btn btn-ghost btn-icon btn-sm" onClick={() => openEdit(sub)}>✏️</button>
                        <button className="btn btn-danger btn-icon btn-sm" onClick={() => handleDelete(sub.id, sub.name)}>🗑</button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={e => e.target===e.currentTarget && setShowModal(false)}>
          <div className="modal">
            <div className="modal-header">
              <h3 className="modal-title">
                {editId ? 'Editar' : form.parent_id ? 'Nueva subcategoría' : 'Nueva categoría'}
              </h3>
              <button className="modal-close" onClick={() => setShowModal(false)}>✕</button>
            </div>
            <form onSubmit={handleSave} style={{ display:'flex', flexDirection:'column', gap:16 }}>
              {/* Type toggle — only for parent categories */}
              {!form.parent_id && !editId && (
                <div style={styles.typeToggle}>
                  {[['expense','Gasto'],['income','Ingreso']].map(([v,l]) => (
                    <button key={v} type="button" onClick={() => setForm({...form, type:v})}
                      style={{ ...styles.typeBtn, ...(form.type===v ? styles.typeBtnActive : {}) }}>
                      {l}
                    </button>
                  ))}
                </div>
              )}

              {/* Parent selector — for subcategories */}
              {form.parent_id && (
                <div className="form-group">
                  <label className="form-label">Categoría padre</label>
                  <select className="form-select" value={form.parent_id}
                    onChange={e => setForm({...form, parent_id:e.target.value})}>
                    {parentOptions.map(c => <option key={c.id} value={c.id}>{c.icon} {c.name}</option>)}
                  </select>
                </div>
              )}

              <div className="form-group">
                <label className="form-label">Nombre</label>
                <input type="text" className="form-input" placeholder="Nombre de la categoría"
                  value={form.name} onChange={e => setForm({...form, name:e.target.value})} required />
              </div>

              <div className="form-group">
                <label className="form-label">Ícono</label>
                <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
                  {ICONS.map(ic => (
                    <button key={ic} type="button" onClick={() => setForm({...form, icon:ic})}
                      style={{ width:40, height:40, borderRadius:10, border: form.icon===ic ? '2px solid var(--accent)' : '1px solid var(--border)',
                        background: form.icon===ic ? 'var(--accent-glow)' : 'transparent', cursor:'pointer', fontSize:20 }}>
                      {ic}
                    </button>
                  ))}
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Color</label>
                <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                  {COLORS.map(c => (
                    <button key={c} type="button" onClick={() => setForm({...form, color:c})}
                      style={{ width:32, height:32, borderRadius:'50%', background:c, border: form.color===c ? '3px solid white' : 'none', cursor:'pointer' }} />
                  ))}
                </div>
              </div>

              <div style={{ display:'flex', gap:10 }}>
                <button type="button" className="btn btn-secondary" style={{ flex:1 }} onClick={() => setShowModal(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary" style={{ flex:2 }} disabled={saving}>
                  {saving ? <span className="spinner" /> : (editId ? 'Guardar' : 'Crear')}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  page: { display:'flex', flexDirection:'column', gap:20 },
  tabs: { display:'flex', background:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:'var(--radius)', padding:4, gap:4 },
  tab: { flex:1, padding:'10px 16px', border:'none', borderRadius:12, background:'transparent', color:'var(--text-secondary)', cursor:'pointer', fontFamily:'var(--font-body)', fontSize:'0.9rem', fontWeight:500, transition:'all 0.2s' },
  tabActive: { background:'var(--bg-card-hover)', color:'var(--text-primary)', boxShadow:'inset 0 0 0 1px var(--border)' },
  catRow: { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'16px 16px' },
  subList: { borderTop:'1px solid var(--border-light)', padding:'8px 16px 12px', display:'flex', flexDirection:'column', gap:4 },
  subRow: { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'8px 12px', borderRadius:10, background:'var(--bg-input)' },
  empty: { display:'flex', flexDirection:'column', alignItems:'center', gap:14, padding:'40px 20px', color:'var(--text-secondary)', textAlign:'center' },
  typeToggle: { display:'flex', gap:8, background:'var(--bg-input)', borderRadius:'var(--radius-sm)', padding:4 },
  typeBtn: { flex:1, padding:'10px', border:'none', borderRadius:8, cursor:'pointer', fontFamily:'var(--font-body)', fontSize:'0.9rem', fontWeight:600, background:'transparent', color:'var(--text-muted)', transition:'all 0.2s' },
  typeBtnActive: { background:'var(--bg-card-hover)', color:'var(--text-primary)', boxShadow:'inset 0 0 0 1px var(--border)' },
};
